<template>
  <div class="page-container" >
    <ModalLoading :isLoading="cargando" />
    <div class="page-header">
      <div>
      </div>
      <button class="btn-exportar-pdf" @click="exportarPDF" :disabled="exportando || !datos?.filas?.length">
        <i :class="exportando ? 'bi bi-hourglass-split' : 'bi bi-file-earmark-pdf'"></i>
        {{ exportando ? 'Generando...' : 'Exportar PDF' }}
      </button>
    </div>

    <div class="tabs">
      <button :class="['tab', { active: tabActivo === 'ventas' }]" @click="tabActivo = 'ventas'; cargar()">
        <i class="bi bi-receipt"></i> Libro de Ventas
      </button>
      <button :class="['tab', { active: tabActivo === 'compras' }]" @click="tabActivo = 'compras'; cargar()">
        <i class="bi bi-cart3"></i> Libro de Compras
      </button>
    </div>

    <div class="filters-row">
      <div class="filter-group">
        <label>Fecha inicio</label>
        <input v-model="fechaInicio" type="date" class="form-input" />
      </div>
      <div class="filter-group">
        <label>Fecha fin</label>
        <input v-model="fechaFin" type="date" class="form-input" />
      </div>
      <div v-if="esCeo" class="filter-group">
        <label>Sucursal</label>
        <select class="form-select" style="min-width:160px" v-model="filtroSucursal" @change="cargar()">
          <option value="">Todas las sucursales</option>
          <option v-for="s in sucursalesCeo" :key="s.id_sucursal" :value="s.id_sucursal">
            {{ s.nombre_administrativo }}
          </option>
        </select>
      </div>
      <button class="btn-buscar" @click="cargar"><i class="bi bi-search"></i> Generar</button>
    </div>


    <div v-if="datos">
      <div class="summary-totales">
        <template v-if="tabActivo === 'ventas'">
          <div class="card-tot"><span>Exento</span><strong>L. {{ fmtNum(datos.totales.exento) }}</strong></div>
          <div class="card-tot"><span>Gravado 15%</span><strong>L. {{ fmtNum(datos.totales.gravado_15) }}</strong></div>
          <div class="card-tot"><span>ISV 15%</span><strong>L. {{ fmtNum(datos.totales.isv_15) }}</strong></div>
          <div class="card-tot highlight"><span>Total</span><strong>L. {{ fmtNum(datos.totales.total) }}</strong></div>
        </template>
        <template v-else>
          <div class="card-tot"><span>Exento</span><strong>L. {{ fmtNum(datos.totales.exento) }}</strong></div>
          <div class="card-tot"><span>Gravado 15%</span><strong>L. {{ fmtNum(datos.totales.gravado_15) }}</strong></div>
          <div class="card-tot"><span>ISV 15%</span><strong>L. {{ fmtNum(datos.totales.isv_15) }}</strong></div>
          <div class="card-tot"><span>Descuentos</span><strong>L. {{ fmtNum(datos.totales.descuento) }}</strong></div>
          <div class="card-tot highlight"><span>Total</span><strong>L. {{ fmtNum(datos.totales.total) }}</strong></div>
        </template>
      </div>

      <div v-if="!datos.filas.length" class="empty-state">
        <i class="bi bi-journal"></i><p>No hay registros en el período seleccionado.</p>
      </div>

      <!-- Libro de Ventas -->
      <div v-else-if="tabActivo === 'ventas'" class="table-container" id="tabla-libro">
        <table class="data-table sar-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>N° Factura SAR</th>
              <th>Cliente</th>
              <th>RTN</th>
              <th>Tipo Pago</th>
              <th>Exento</th>
              <th>Gravado 15%</th>
              <th>ISV 15%</th>
              <th>Gravado 18%</th>
              <th>ISV 18%</th>
              <th>Total</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(f, i) in datos.filas" :key="i" :class="{ 'row-cancelada': f.estado === 'Cancelada' }">
              <td>{{ f.fecha }}</td>
              <td class="mono">{{ f.numero_factura }}</td>
              <td>{{ f.nombre_cliente }}</td>
              <td class="mono">{{ f.rtn_cliente }}</td>
              <td>{{ f.tipo_factura }}</td>
              <td>{{ fmtNum(f.exento) }}</td>
              <td>{{ fmtNum(f.gravado_15) }}</td>
              <td>{{ fmtNum(f.isv_15) }}</td>
              <td>{{ fmtNum(f.gravado_18) }}</td>
              <td>{{ fmtNum(f.isv_18) }}</td>
              <td><strong>{{ fmtNum(f.total) }}</strong></td>
              <td><span :class="f.estado === 'Cancelada' ? 'badge-danger' : 'badge-success'">{{ f.estado }}</span></td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="fila-total">
              <td colspan="5"><strong>TOTALES</strong></td>
              <td><strong>{{ fmtNum(datos.totales.exento) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.gravado_15) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.isv_15) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.gravado_18) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.isv_18) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.total) }}</strong></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>

      <!-- Libro de Compras -->
      <div v-else class="table-container" id="tabla-libro">
        <table class="data-table sar-table">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>N° Factura</th>
              <th>CAI</th>
              <th>Proveedor</th>
              <th>RTN</th>
              <th>Exento</th>
              <th>Gravado 15%</th>
              <th>ISV 15%</th>
              <th>Descuento</th>
              <th>Total</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(f, i) in datos.filas" :key="i">
              <td>{{ f.fecha }}</td>
              <td class="mono">{{ f.numero_factura }}</td>
              <td class="mono small">{{ f.cai }}</td>
              <td>{{ f.nombre_proveedor }}</td>
              <td class="mono">{{ f.rtn_proveedor }}</td>
              <td>{{ fmtNum(f.exento) }}</td>
              <td>{{ fmtNum(f.gravado_15) }}</td>
              <td>{{ fmtNum(f.isv_15) }}</td>
              <td>{{ fmtNum(f.descuento) }}</td>
              <td><strong>{{ fmtNum(f.total) }}</strong></td>
              <td><span :class="f.estado === 'PAGADO' ? 'badge-success' : 'badge-warning'">{{ f.estado }}</span></td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="fila-total">
              <td colspan="5"><strong>TOTALES</strong></td>
              <td><strong>{{ fmtNum(datos.totales.exento) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.gravado_15) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.isv_15) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.descuento) }}</strong></td>
              <td><strong>{{ fmtNum(datos.totales.total) }}</strong></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getLibroVentas, getLibroCompras, descargarPDFLibroVentas, descargarPDFLibroCompras } from '../../services/featuresSolicitudes.js';
import { getSucursalesbyEmmpresaSumm } from '../../services/sucursalesSolicitudes.js';
import { useToast } from 'vue-toastification';
import { setPageTitle } from '@/components/pageMetadata';
import ModalLoading from "@/components/ModalLoading.vue";

export default {
  name: 'LibrosFiscalesPage',
  components: { ModalLoading },
  data() {
    const token = localStorage.getItem('auth');
    const hoy = new Date();
    const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().split('T')[0];
    const toast = useToast();
    return {
      toast,
      id_usuario: token ? JSON.parse(atob(token.split('.')[1])).id_usuario : null,
      esCeo: Number(localStorage.getItem('role') || 0) === 4,
      sucursalesCeo: [],
      filtroSucursal: '',
      tabActivo: 'ventas',
      fechaInicio: primerDia,
      fechaFin: hoy.toISOString().split('T')[0],
      datos: null,
      cargando: false,
      exportando: false,
      requestSeq: 0
    };
  },
  async mounted() {
    setPageTitle('Libros Fiscales');
    if (this.esCeo) {
      this.sucursalesCeo = await getSucursalesbyEmmpresaSumm(this.id_usuario);
      if (!Array.isArray(this.sucursalesCeo)) this.sucursalesCeo = [];
    }
    await this.cargar();
  },
  methods: {
    async cargar() {
      const seq = ++this.requestSeq;
      this.cargando = true;
      this.datos = null;
      const suc = this.filtroSucursal || null;
      try {
        const result = this.tabActivo === 'ventas'
          ? await getLibroVentas(this.id_usuario, this.fechaInicio, this.fechaFin, suc)
          : await getLibroCompras(this.id_usuario, this.fechaInicio, this.fechaFin, suc);
        if (seq === this.requestSeq) this.datos = result;
      } catch (e) {
        if (seq === this.requestSeq) console.error(e);
      } finally {
        if (seq === this.requestSeq) this.cargando = false;
      }
    },
    async exportarPDF() {
      if (!this.datos?.filas?.length) { this.toast.warning('No hay datos para exportar'); return; }
      this.exportando = true;
      const suc = this.filtroSucursal || null;
      try {
        if (this.tabActivo === 'ventas') {
          await descargarPDFLibroVentas(this.id_usuario, this.fechaInicio, this.fechaFin, suc);
        } else {
          await descargarPDFLibroCompras(this.id_usuario, this.fechaInicio, this.fechaFin, suc);
        }
        this.toast.success('PDF descargado correctamente');
      } catch (e) { this.toast.error('Error al generar PDF: ' + e.message); }
      finally { this.exportando = false; }
    },
    fmtNum(n) { return Number(n || 0).toLocaleString('es-HN', { minimumFractionDigits: 2 }); }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

* { font-family: "Montserrat", sans-serif; box-sizing: border-box; }

/* ── Page Layout ── */
.page-container { padding: 16px; width: 100%; overflow-x: hidden; background: #ffffff; min-height: 100vh; color: #212529; }
.page-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; margin-bottom: 20px; padding: 0 4px; }
.page-header h1 { font-size: clamp(22px, 4vw, 30px); font-weight: 700; margin: 8px 0; color: #333; }
.subtitle { font-size: 0.875rem; color: #6c757d; margin: 0; }
.opciones { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; margin-bottom: 16px; }

/* ── Inputs ── */
.busqueda, .form-input { padding: 8px 12px; font-size: 14px; border-radius: 10px; border: 1px solid #ced4da; outline: none; background: white; color: #212529; transition: all 0.3s ease; }
input:focus, select:focus, textarea:focus { border-color: #c09d62; box-shadow: 0 0 0 3px rgba(192,157,98,0.2); outline: none; }
.form-select, select { padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; cursor: pointer; background: white; color: #212529; }
.form-textarea { width: 100%; padding: 8px 12px; border-radius: 10px; border: 1px solid #ced4da; font-family: "Montserrat", sans-serif; font-size: 14px; resize: vertical; outline: none; background: white; color: #212529; }

/* ── Buttons ── */
.btn-primary { background-color: #c09d62; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-primary:hover { background-color: #a38655; transform: scale(1.02); }
.btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-exportar-pdf { background-color: #198754; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-exportar-pdf:hover:not(:disabled) { background-color: #146c43; transform: scale(1.02); }
.btn-exportar-pdf:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-cancel, .btn-secondary { background-color: #6c757d; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; }
.btn-cancel:hover, .btn-secondary:hover { background-color: #5a6268; }
.btn-danger { background-color: #dc3545; color: white; padding: 8px 16px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; }
.btn-danger:hover { background-color: #b02a37; }
.btn-icon { width: 32px; height: 32px; border-radius: 8px; border: 1px solid #dee2e6; background: white; color: #495057; cursor: pointer; font-size: 14px; display: inline-flex; align-items: center; justify-content: center; transition: all 0.3s ease; }
.btn-icon:hover { background: #f8f9fa; transform: scale(1.05); }
.btn-icon.success { background: #d1e7dd; color: #0f5132; border-color: #a3cfbb; }
.btn-icon.success:hover { background: #0f5132; color: white; }
.btn-icon.danger { background: #f8d7da; color: #842029; border-color: #f1aeb5; }
.btn-icon.danger:hover { background: #842029; color: white; }
.btn-icon.info { background: #cff4fc; color: #055160; border-color: #9eeaf9; }
.btn-icon.info:hover { background: #055160; color: white; }
.btn-icon:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
.btn-close-x { background: none; border: none; cursor: pointer; font-size: 1rem; color: #6c757d; padding: 4px; border-radius: 6px; display: flex; align-items: center; }
.btn-close-x:hover { color: #212529; background: #f8f9fa; }

/* ── Loading / Empty ── */
.loading { display: flex; justify-content: center; padding: 3rem; }
.spinner { width: 36px; height: 36px; border: 3px solid #f3f3f3; border-top: 3px solid #c09d62; border-radius: 50%; animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.empty-state { display: flex; flex-direction: column; align-items: center; padding: 3rem; gap: 12px; color: #6c757d; text-align: center; }
.empty-state i { font-size: 2.5rem; opacity: 0.4; }

/* ── Table ── */
.table-container { width: 100%; overflow-x: auto; -webkit-overflow-scrolling: touch; margin-bottom: 20px; border-radius: 8px; border: 1px solid #e2e8f0; }
.table-container::-webkit-scrollbar { width: 8px; height: 8px; }
.table-container::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.table-container::-webkit-scrollbar-thumb { background: #c09d62; border-radius: 4px; }
.table-container::-webkit-scrollbar-thumb:hover { background: #a38655; }
.data-table, .table { width: 100%; border-collapse: collapse; font-size: 0.875rem; }
.data-table th, .table th { padding: 8px 12px; text-align: left; font-weight: 700; font-size: 0.8rem; border-bottom: 2px solid #dee2e6; background: #f8f9fa; position: sticky; top: 0; z-index: 1; white-space: nowrap; color: #495057; }
.data-table td, .table td { padding: 8px 12px; border-bottom: 1px solid #dee2e6; vertical-align: middle; color: #212529; background: white; }
.data-table tbody tr:last-child td, .table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover td, .table tbody tr:hover td { background-color: #f8f9fa; }

/* ── Texto ── */
.text-danger { color: #dc3545 !important; }
.text-warning { color: #856404 !important; }
.text-success { color: #0f5132 !important; }
.text-muted { color: #6c757d; }

/* ── Badges ── */
.estado-badge, .badge { padding: 3px 8px; font-size: 0.75rem; border-radius: 12px; font-weight: 600; display: inline-block; }
.estado-pendiente, .badge-info, .badge-pendiente { background-color: #fff3cd; color: #856404; }
.estado-pagado, .badge-success, .badge-pagado { background-color: #d1e7dd; color: #0f5132; }
.estado-parcial, .badge-parcial { background-color: #d1ecf1; color: #0c5460; }
.badge-danger, .estado-rechazado, .badge-rechazado, .estado-vencido { background-color: #f8d7da; color: #842029; }
.badge-facturada, .estado-facturada, .badge-facturado { background-color: #e2e8f0; color: #495057; }

/* ── Acciones ── */
.actions-column, .actions { display: flex; gap: 8px; justify-content: center; align-items: center; }

/* ── Modal ── */
.modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 9000; padding: 1rem; }
.modal-box, .modal-content, .modal-large { background: white; border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.2); width: 100%; max-width: 600px; max-height: 90vh; display: flex; flex-direction: column; overflow: hidden; }
.modal-large { max-width: 750px; }
.modal-header { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid #dee2e6; background: #f8f9fa; }
.modal-header h2, .modal-header h3 { font-size: 1rem; font-weight: 700; margin: 0; color: #212529; }
.modal-body { padding: 1.25rem; overflow-y: auto; flex: 1; background: white; }
.modal-footer { padding: 1rem 1.25rem; border-top: 1px solid #dee2e6; display: flex; gap: 8px; justify-content: flex-end; background: #f8f9fa; }

/* ── Forms ── */
.form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 12px; }
.form-group { display: flex; flex-direction: column; gap: 4px; margin-bottom: 12px; }
.form-group label { font-size: 0.8rem; font-weight: 600; color: #495057; }
.form-group .form-input, .form-group .form-select, .form-group textarea { width: 100%; }

/* ── Pagination ── */
.pagination-wrapper { display: flex; justify-content: space-between; align-items: center; padding: 1rem; border-top: 1px solid #dee2e6; }
.pagination-info { color: #6c757d; font-size: 0.875rem; }
.pagination-container { display: flex; gap: 5px; }
.pagination-button { padding: 6px 14px; border: 1px solid #dee2e6; background: white; cursor: pointer; border-radius: 6px; font-size: 0.875rem; font-family: "Montserrat", sans-serif; transition: all 0.3s ease; }
.pagination-button:hover, .pagination-button.active { background: #c09d62; color: white; border-color: #c09d62; }
.pagination-button:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Tabs ── */
.tabs { display: flex; gap: 6px; margin-bottom: 16px; border-bottom: 2px solid #dee2e6; padding-bottom: 0; }
.tab { padding: 8px 20px; border: 1px solid #dee2e6; border-bottom: none; border-radius: 8px 8px 0 0; background: #f8f9fa; color: #6c757d; font-size: 0.875rem; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.2s; font-family: "Montserrat", sans-serif; margin-bottom: -2px; }
.tab:hover { background: #e9ecef; color: #495057; }
.tab.active { background: white; color: #c09d62; border-color: #dee2e6; border-bottom: 2px solid white; }

/* ── Filters ── */
.filters-row { display: flex; flex-wrap: wrap; align-items: flex-end; gap: 12px; margin-bottom: 16px; background: #f8f9fa; padding: 12px 14px; border-radius: 10px; border: 1px solid #dee2e6; }
.filter-group { display: flex; flex-direction: column; gap: 4px; }
.filter-group label { font-size: 0.78rem; font-weight: 600; color: #495057; }
.btn-buscar { background-color: #c09d62; color: white; padding: 8px 18px; border: none; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; transition: all 0.3s ease; font-family: "Montserrat", sans-serif; align-self: flex-end; }
.btn-buscar:hover { background-color: #a38655; }

/* ── Summary totals ── */
.summary-totales { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
.card-tot { flex: 1; min-width: 130px; background: white; border: 1px solid #dee2e6; border-radius: 10px; padding: 12px 16px; display: flex; flex-direction: column; gap: 4px; }
.card-tot span { font-size: 0.75rem; color: #6c757d; font-weight: 600; text-transform: uppercase; letter-spacing: 0.03em; }
.card-tot strong { font-size: 1rem; color: #212529; font-weight: 700; }
.card-tot.highlight { border-color: #c09d62; background: #fffaf2; }
.card-tot.highlight strong { color: #c09d62; font-size: 1.1rem; }

/* ── Text utils ── */
.mono { font-family: "Courier New", monospace; font-size: 0.8rem; color: #495057; letter-spacing: 0.03em; }
.small { font-size: 0.72rem; }

/* ── SAR table specifics ── */
.sar-table { font-size: 0.8rem; }
.sar-table th { font-size: 0.72rem; padding: 7px 10px; }
.sar-table td { padding: 7px 10px; }
.row-cancelada td { background: #fff5f5 !important; color: #842029; text-decoration: line-through; opacity: 0.85; }
.fila-total td { background: #f8f9fa; border-top: 2px solid #c09d62; font-weight: 700; color: #212529; }

/* ── Badge warning (faltante) ── */
.badge-warning { background-color: #fff3cd; color: #856404; padding: 3px 8px; font-size: 0.75rem; border-radius: 12px; font-weight: 600; display: inline-block; }

@media (max-width: 640px) {
  .form-row { grid-template-columns: 1fr; }
  .page-header { flex-direction: column; }
  .filters-row { flex-direction: column; }
  .summary-totales { flex-direction: column; }
}

/* ── Dark Mode ── */
.dark .page-container { background: #1e1e1e; color: #e5e5e5; }
.dark .page-header h1 { color: #e5e5e5; }
.dark .subtitle { color: #9e9e9e; }
.dark .form-input, .dark .busqueda { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-select, .dark select { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .form-textarea { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .table-container { border-color: #404040; }
.dark .data-table th, .dark .table th { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .data-table td, .dark .table td { background: #1e1e1e; color: #e5e5e5; border-color: #404040; }
.dark .data-table tbody tr:hover td, .dark .table tbody tr:hover td { background: #2d2d2d; }
.dark .pagination-wrapper { border-color: #404040; }
.dark .pagination-info { color: #9e9e9e; }
.dark .pagination-button { background: #2d2d2d; color: #e5e5e5; border-color: #404040; }
.dark .pagination-button:hover:not(:disabled), .dark .pagination-button.active { background: #c09d62; color: white; border-color: #c09d62; }
.dark .btn-icon { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .btn-icon:hover { background: #3d3d3d; }
.dark .btn-close-x { color: #9e9e9e; }
.dark .btn-close-x:hover { color: #e5e5e5; background: #3d3d3d; }
.dark .form-group label { color: #9e9e9e; }
.dark .modal-box, .dark .modal-content, .dark .modal-large { background: #1e1e1e; }
.dark .modal-header { background: #2d2d2d; border-color: #404040; }
.dark .modal-header h2, .dark .modal-header h3 { color: #e5e5e5; }
.dark .modal-body { background: #1e1e1e; }
.dark .modal-footer { background: #2d2d2d; border-color: #404040; }
.dark .empty-state { color: #9e9e9e; }
.dark .tabs { border-color: #404040; }
.dark .tab { background: #2d2d2d; color: #9e9e9e; border-color: #404040; }
.dark .tab:hover { background: #3d3d3d; color: #e5e5e5; }
.dark .tab.active { background: #1e1e1e; color: #c09d62; border-color: #404040; border-bottom-color: #1e1e1e; }
.dark .filters-row { background: #2d2d2d; border-color: #404040; }
.dark .filter-group label { color: #9e9e9e; }
.dark .card-tot { background: #2d2d2d; border-color: #404040; }
.dark .card-tot span { color: #9e9e9e; }
.dark .card-tot strong { color: #e5e5e5; }
.dark .card-tot.highlight { background: #2a2215; border-color: #c09d62; }
.dark .mono { color: #9e9e9e; }
.dark .fila-total td { background: #2d2d2d; color: #e5e5e5; }
.dark .row-cancelada td { background: #2a1515 !important; color: #f5c6cb; }
</style>